import React from "react";
import { Grid, Modal, Pagination } from "semantic-ui-react";
import "../auth.css";
import "../card.css";
import "../sidemenu.css";
import { Link } from "react-router-dom";
import axios from "axios";
import { reactLocalStorage } from "reactjs-localstorage";
import i18n from "../i18n";
import { connect } from "react-redux";
import Menutest from "./menu.js";
import Table from "react-bootstrap/Table";
import {
  Message,
  Icon,
  Segment,
  Header,
  Button,
  Divider,
  Input,
} from "semantic-ui-react";
import { SemanticToastContainer, toast } from "react-semantic-toasts";
import { API_BASE_URL } from "../utils/endpoints";

//import Modal from "react-modal";

// import "react-phone-input-2/dist/style.css";
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    height: "100",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    overflow: "auto",
  },
};

const modadd = {
  marginTop: 150,
  marginLeft: "35%",
  height: "auto",
  textAlign: "left",
};

const modadda = {
  marginTop: 150,
  marginLeft: "25%",
  height: "auto",
  textAlign: "right",
};

class SubAdminJobs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      totalpage: "1",
      activePage: 1,
      searchTotalPae: "1",
      searchActivePage: 1,
      searchWord: "",
      modalIsOpen: false,
      detailsData: [],
      detailsTotalpage: "1",
      detailsActivePage: 1,

      subAdminId: "",
      jobId: "",
    };
  }

  componentDidMount() {
    var lang = i18n.language;
    document.querySelector(".searchPagination").style = "display:none";
    document.querySelector(".pagination").style = "display:block";
    if (lang === "ar") {
      document.querySelector(".ko7le_color").style =
        "text-align:right;width: 20%;margin-right: 14%;white-space: pre;";
      document.querySelector(".icon_logo").style =
        "float: left;margin-top: 0%; margin-right: -5%;width: 7%;cursor: pointer; margin-left: -11%;";
      document.querySelector(".list_ar").style = "display:block";
      document.querySelector(".list_en").style = "display:none";
    }

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var page_num = 0;
    var token = reactLocalStorage.get("accessToken");
    var adminId = reactLocalStorage.get("user_id_login");
    if (ip.includes(s2)) {
      apiBaseUrl = API_BASE_URL + `/core/user/rest/jobs/subAdmin/${adminId}?page=${page_num}&size=20`;
    }
    else {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/jobs/subAdmin/" + adminId + "?page=" + page_num + "&size=20";
    }
    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      this.setState({ data: res.data.result.result });
    });
  }

  handlePaginationChange = (e, { activePage }) => {
    this.setState({ activePage });
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var page_num = activePage - 1;
    var token = reactLocalStorage.get("accessToken");
    var adminId = reactLocalStorage.get("user_id_login");
    if (ip.includes(s2)) {
      apiBaseUrl = API_BASE_URL + `/core/user/rest/jobs/subAdmin/${adminId}?page=${page_num}&size=20`;
    }
    else {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/jobs/subAdmin/" + adminId + "?page=" + page_num + "&size=20";
    }
    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      this.setState({ data: res.data.result.result });
    });
  };

  searchchange = (event) => {
    if (event.target.value.length >= 2) {
      document.querySelector(".searchPagination").style = "display:block";
      document.querySelector(".pagination").style = "display:none";
      var token = reactLocalStorage.get('accessToken');
      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      this.setState({
        searchWord: event.target.value,
      });
      var page_num = 0;
      var body = {
        page: page_num,
        searchQuery: event.target.value,
      };
      if (ip.includes(s2)) {
        apiBaseUrl = API_BASE_URL + "/core/user/rest/jobs/searchJobs/subadmin";
      }
      else {
        apiBaseUrl = API_BASE_URL + "/core/user/rest/jobs/searchJobs/subadmin"
      }


      var headers = { 'Content-Type': 'application/json', 'token': token }
      axios.post(apiBaseUrl, body, { headers: headers })
        .then(res => {
          this.setState({ personssearch: res.data.result.jobs })

        })
    } else {
      document.querySelector(".searchPagination").style = "display:none";
      document.querySelector(".pagination").style = "display:block";

      this.componentDidMount();
    }
  };

  handlePaginationChangeSearch = (e, { activePage }) => {
    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;

    var page_num = activePage - 1;
    var body = {
      page: page_num,
      searchQuery: this.state.searchWord,
    };
    if (ip.includes(s2)) {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/jobs/searchJobs/subadmin";
    }
    else {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/jobs/searchJobs/subadmin"
    }


    var headers = { 'Content-Type': 'application/json', 'token': token }
    axios.post(apiBaseUrl, body, { headers: headers })
      .then(res => {
        this.setState({ personssearch: res.data.result.jobs })

      })
  };

  test(value) {
    var d = new Date(value),
      dformat =
        [d.getMonth() + 1, d.getDate(), d.getFullYear()].join("/") +
        " " +
        [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
    return dformat;
  }

  viewdata(userId, jobId) {
    var x = this;
    console.log("hello");
    x.setState({
      modalIsOpen: true,
      subAdminId: userId,
      jobId: jobId,
    });

    var token = reactLocalStorage.get("accessToken");


    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl = 
          API_BASE_URL + `/core/user/rest/jobs/sub_admin_id=${userId}/job=${jobId}/page=0/getJobDetailsSub`;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        `/core/user/rest/jobs/sub_admin_id=${userId}/job=${jobId}/page=0/getJobDetailsSub`
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.post(apiBaseUrl, {}, { headers: headers }).then((res) => {
      var total = Math.ceil(res.data.result.messages_count / 20);

      this.setState({ totalpage: total });
      let result = res.data.result.result;

      if (result !== undefined) {
        this.setState({ detailsData: result });
      }
    });
  }

  handlePaginationChangeDetails = (e, { activePage }) => {
    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;

    var page_num = this.state.detailsActivePage - 1;

    if (ip.includes(s2)) {
      apiBaseUrl = 
              API_BASE_URL + `/core/user/rest/jobs/sub_admin_id=${this.state.subAdminId}/job=${this.state.jobId}/page=${page_num}/getJobDetailsSub`;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        `/core/user/rest/jobs/sub_admin_id=${this.state.subAdminId}/job=${this.state.jobId}/page=${page_num}/getJobDetailsSub`
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.post(apiBaseUrl, {}, { headers: headers }).then((res) => {
      this.setState({ detailsData: res.data.result.result });
    });
  };

  render() {
    return (
      <div className="big_div">
        <Menutest />
        <div className="actionMenu">
          <div className="main_div_contact">
            <div className="main_contact ">
              <Grid columns={2} divided className="fixed_contact">
                <Grid.Row stretched className="fixed_header disable_z">
                  <Grid.Column className="grid_logo">
                    <Segment>
                      <h3 className="text_style darked_color">
                        {this.state.isArabic ? (
                          <img
                            alt=""
                            src={require("../pictures/ArabicHedar.png")}
                            style={{
                              width: "100% !important",
                              height: "117px",
                              marginTop: "8px",
                              marginRight: "-13px",
                            }}
                            className="himage"
                          />
                        ) : (
                          <img
                            alt=""
                            src={require("../pictures/EnglishHedar.png")}
                            style={{
                              width: "100% !important",
                              height: "117px",
                              marginLeft: "-13px",
                              marginTop: "8px",
                            }}
                            className="himage"
                          />
                        )}
                      </h3>
                    </Segment>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </div>

          <br />
          <br />
          <br />
          <br />
          <div
            className="container_cards"
            style={{ paddingRight: this.state.isArabic ? "" : "20px" }}
          >
            <div
              className={
                this.state.isArabic ? "content_reportarabic" : "content_report"
              }
            >
              <br />
              <Segment
                color="black"
                style={{ padding: "20px", minHeight: "200px" }}
              >
                <br />

                <Divider horizontal>
                  <Header as="h2">
                    <Icon name="wpforms" size="tini" color="black" />

                    {this.state.isArabic
                      ? "وظائف الإدارة الفرعية"
                      : "SubAdmin Jobs"}
                  </Header>
                </Divider>
                <br />

                <div className="buttonsHeader">
                  <Input
                    size="small"
                    icon="search"
                    color="black"
                    placeholder={
                      this.state.isArabic
                        ? "البحث عن رقم "
                        : "Search By Number "
                    }
                    onChange={this.searchchange.bind(this)}
                    style={{ float: "right" }}
                  />
                  {/*  <Button
                    floated="right"
                    icon
                    labelPosition="left"
                    basic
                    size="small"
                    onClick={this.handleOpenFilterDetails}
                  >
                    <Icon name="sort amount up" /> {i18n.t("filter.label")}
                  </Button> */}
                  <Button
                    floated="right"
                    icon
                    labelPosition="left"
                    basic
                    size="small"
                    onClick={() => {
                      this.componentDidMount();
                    }}
                  >
                    <Icon name="refresh" />{" "}
                    {this.state.isArabic ? "تحديث" : "Refresh"}
                  </Button>
                </div>

                <br />
                <br />
                <Table
                  hover
                  responsive
                  border="0"
                  style={{ textAlign: this.state.isArabic ? "right" : "left" }}
                >
                  <thead>
                    <tr style={{ textAlign: "center" }}>
                      <th />

                      <th className="th_child">{i18n.t("job_title.label")}</th>
                      <th className="th_child">{i18n.t("sender_id.label")}</th>
                      <th className="th_child1">{i18n.t("Status.label")}</th>

                      <th className="th_child2">
                        {i18n.t("Schedule_date.label")}
                      </th>
                      <th>{i18n.t("numberofmsgs.label")}</th>
                      <th className="total_report">
                        {i18n.t("total_recipients.label")}
                      </th>
                      <th>{i18n.t("total_delievered.label")}</th>
                      <th>{i18n.t("total_failed.label")}</th>
                      <th>{i18n.t("total_rejected.label")}</th>
                      <th>{i18n.t("total_submitted.label")}</th>
                      <th>{i18n.t("total_invalid.label")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.data.map((person) => (
                      <tr>
                        <td className="approve_cycle">
                          <Button
                            onClick={() =>
                              this.viewdata(person.user_id, person.id)
                            }
                            className="view_details"
                          >
                            {i18n.t("view_details.label")}{" "}
                          </Button>
                        </td>
                        <td className="bulk_data">{person.title}</td>
                        <td className="bulk_data">{person.sender_id}</td>
                        <td className="bulk_data">{person.status}</td>
                        <td className="bulk_data">
                          {" "}
                          {person.schedule_date
                            ? this.test(person.schedule_date)
                            : ""}
                        </td>
                        <td className="bulk_data">{person.total_messages}</td>
                        <td className="bulk_data">{person.total_recipients}</td>
                        <td className="bulk_data">{person.total_delievered}</td>
                        <td className="bulk_data">{person.total_failed}</td>
                        <td className="bulk_data">{person.total_rejected}</td>
                        <td className="bulk_data">{person.total_submitted}</td>
                        <td className="bulk_data">{person.total_invalid}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>

                <div className="pagination">
                  <Pagination
                    activePage={this.state.activePage}
                    onPageChange={this.handlePaginationChange}
                    totalPages={this.state.totalpage}
                    className="page"
                    style={{ marginRight: "2.5%" }}
                  />
                </div>

                <div className="searchPagination">
                  <Pagination
                    activePage={this.state.searchActivePage}
                    onPageChange={this.handlePaginationChangeSearch}
                    totalPages={this.state.searchTotalPae}
                    className="page"
                    style={{ marginRight: "2.5%" }}
                  />
                </div>
              </Segment>
            </div>

            {/* //////////////////////////////////////////////////////////////////////////////////////////////// */}
          </div>

          <br />
        </div>

        <SemanticToastContainer />

        <Modal
          closeIcon={{
            style: { top: "0rem", right: "0rem" },
            color: "black",
            name: "close",
          }}
          size="tiny"
          className="add"
          open={this.state.modalIsOpen}
          onClose={() =>
            this.setState({
              modalIsOpen: false,
            })
          }
          style={reactLocalStorage.get("lang") === "ar" ? modadda : modadd}
        >
          <h2
            ref={(subtitle) => (this.subtitle = subtitle)}
            className="report_title"
            style={{
              textAlign: this.state.isArabic ? "right" : "",
              marginRight: this.state.isArabic ? "2%" : "",
            }}
          >
            {i18n.t("Details.label")}
          </h2>

          <br />
          <div className="" style={{ marginTop: "-3%" }}>
            <div className="view_basics view_report">
              <Table celled inverted selectable>
                <thead>
                  <tr>
                    <th
                      style={{
                        textAlign: this.state.isArabic ? "right" : "",
                      }}
                    >
                      {i18n.t("Mobile_Number.label")}
                    </th>
                    <th
                      style={{
                        textAlign: this.state.isArabic ? "right" : "",
                      }}
                    >
                      {i18n.t("Status.label")}
                    </th>
                    <th
                      style={{
                        textAlign: this.state.isArabic ? "right" : "",
                      }}
                    >
                      {i18n.t("Message.label")}
                    </th>
                    <th
                      style={{
                        textAlign: this.state.isArabic ? "right" : "",
                      }}
                    >
                      {i18n.t("Schedule_date.label")}
                    </th>
                  </tr>
                </thead>

                {this.state.detailsData.map((person) => (
                  <tbody>
                    <tr>
                      <td
                        style={{
                          textAlign: this.state.isArabic ? "right" : "",
                        }}
                      >
                        {person.reciepint_number}
                      </td>
                      <td
                        style={{
                          textAlign: this.state.isArabic ? "right" : "",
                        }}
                      >
                        {person.delivery_status}
                      </td>
                      <td
                        style={{
                          textAlign: this.state.isArabic ? "right" : "",
                          direction: "rtl",
                        }}
                      >
                        {person.message_Content}
                      </td>
                      <td
                        style={{
                          textAlign: this.state.isArabic ? "right" : "",
                        }}
                      >
                        {person.send_time}
                      </td>
                    </tr>
                  </tbody>
                ))}
              </Table>

              <Pagination
                activePage={this.state.detailsActivePage}
                onPageChange={this.handlePaginationChangeDetails}
                totalPages={this.state.detailsTotalpage}
                style={{ float: this.state.isArabic ? "left" : "" }}
              />

              <Button
                onClick={() =>
                  this.setState({
                    modalIsOpen: false,
                  })
                }
                className="close_report"
                style={{ marginBottom: "2%" }}
              >
                {i18n.t("Close.label")}
              </Button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return { ...state };
};
export default connect(mapStateToProps)(SubAdminJobs);
